export default "__VITE_ASSET__Nrjo$5aY__"